import { Link } from 'react-router-dom';

const pillars = [
  {
    icon: 'ri-archive-2-line',
    title: '洞洞杂货铺是什么',
    desc: '从零认识这家只对有缘人敞开大门、货架上每件商品都缺一角的神秘小店。',
  },
  {
    icon: 'ri-earth-line',
    title: '世界观与故事背景',
    desc: '三层世界结构、交易三铁律、库房的隐藏秩序，梳理完整设定逻辑。',
  },
  {
    icon: 'ri-circle-line',
    title: '“洞洞”含义解读',
    desc: '从字面、象征到哲学三个层面，层层剥开全作最深层的主题。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '角色与店主来历',
    desc: '那位温声细语的女店主身上，藏着全作最扣人心弦的温柔悬念。',
  },
];

export default function Introduction() {
  return (
    <section className="mx-auto max-w-6xl px-4 py-16 md:px-6 md:py-20">
      <div className="grid items-center gap-12 lg:grid-cols-2">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-xs font-medium text-accent-800">
            <i className="ri-book-open-line text-sm" aria-hidden="true"></i>
            一站看懂设定逻辑
          </span>
          <h2 className="mt-5 text-2xl leading-relaxed text-foreground-950 md:text-3xl">
            关于《洞洞杂货铺》，你需要知道的都在这里
          </h2>
          <p className="mt-5 text-base leading-relaxed text-foreground-700">
            洞洞杂货铺是一部以“人情与缺口”为核心的单元剧漫画。货架上的每一件商品都留着一个小小的“洞”，每一个洞都对应着某个人生命里正缺失的一部分。
          </p>
          <p className="mt-4 text-base leading-relaxed text-foreground-600">
            本站从世界观、故事背景到“洞洞”的含义，为你梳理这部漫画的完整设定，帮你在最短时间内看懂它的独特逻辑与温情内核。
          </p>
          <Link
            to="/lore"
            className="mt-7 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            阅读全部设定文章
            <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="grid gap-4 sm:grid-cols-2">
          {pillars.map((p, i) => (
            <div
              key={p.title}
              className={`rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200 hover:bg-background-100 ${
                i % 2 === 1 ? 'sm:mt-6' : ''
              }`}
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                <i className={`${p.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 text-base font-semibold text-foreground-950">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}